import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ProxmoxService } from '../../../services/proxmox.service';

@Component({
  selector: 'app-client-navbar',
  templateUrl: './client-navbar.component.html',
  styleUrls: ['./client-navbar.component.scss']
})
export class ClientNavbarComponent implements OnInit {
  isLoggedIn: boolean = false;

  constructor(
    private proxmoxService: ProxmoxService,
    private router: Router
  ) { }

  ngOnInit(): void {
    this.isLoggedIn = this.proxmoxService.isAuthenticated();
  }

  onLogout(): void {
    this.proxmoxService.logout();
    this.isLoggedIn = false;
    this.router.navigate(['/client-login']);
  }
}